"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const creditcardbackview = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 194 121",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-creditcardbackview` : '') + (description ? ` desc-creditcardbackview` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-creditcardbackview"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-creditcardbackview"
  }, description), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#ccc",
    width: "194",
    height: "121",
    ry: "5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#999a9d",
    y: "19.47",
    width: "194",
    height: "25.32"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#fff",
    y: "76.46",
    width: "114",
    height: "18.32"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#fff",
    x: "149.99",
    y: "76.46",
    width: "24.01",
    height: "18.32"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    fill: "none",
    stroke: "#cb2026",
    cx: "162.85",
    cy: "85.86",
    rx: "27.8",
    ry: "17.67"
  }));
};
var _default = exports.default = creditcardbackview;